export interface CreditBoosterSale {
  name: string
  title: string
  description?: string
  icon?: string
  credits: number | null
  sold: boolean
}

const byCreditsDescending = (first: CreditBoosterSale, second: CreditBoosterSale) =>
  (second.credits || 0) - (first.credits || 0)

const salesToWin = (sales: CreditBoosterSale[]) => sales.filter(sale => !sale.sold).sort(byCreditsDescending)

const salesWon = (sales: CreditBoosterSale[]) => sales.filter(sale => sale.sold).sort(byCreditsDescending)

export const orderQuests = (sales: CreditBoosterSale[]) => [...salesToWin(sales), ...salesWon(sales)]

export const orderSegments = (sales: CreditBoosterSale[]) => [...salesWon(sales), ...salesToWin(sales)]
